export const URL_PARAMS = {
  SORT: 'sort',
  ORDER: 'order',
  SEARCH: 'search',
  PAGE: 'page',
  TEAM_ID: 'team_id',
  RULE_ID: 'rule_id',
  STATE: 'state',
  CATEGORY: 'categories',
  ACTION_LEVEL: 'actionLevel',
  FINDING_TYPE: 'findingType',
  GIT_REPO_NAME: 'gitRepoName',
  PR_URL: 'prUrl',
  PR_AUTHOR: 'prAuthor',
  PERSONA: 'persona',
  WINDOW_DAYS: 'windowDays',
  CREATED_FROM: 'createdFrom',
  CREATED_TO: 'createdTo',
  SHOW_HIDDEN_ACTIONS: 'show_hidden_actions',
  SCOPES: 'scopes',
  SOURCE: 'source',
  SOURCE_TYPE: 'sourceTypes',
  PROVIDER: 'provider',
  INSTALLATION_ID: 'installationId',
  TAB: 'tab',
  CODE_REVIEW_ENABLED: 'codeReviewEnabled',
} as const;

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export const HTTP_STATUS_CODE_PREFIX_REGEX = /^\d+:\s*/;

/**************************
 * Documentation and Support URLs
 *************************/
export const DOCUMENTATION_URL = 'https://docs.qodo.ai/qodo-documentation';
export const CONTACT_SUPPORT_URL = 'https://www.qodo.ai/contact/';
export const SUPPORT_REQUEST_URL = 'https://help.qodo.ai/hc/en-us/requests/new';
export const MIGRATION_TERMS_URL = 'https://www.qodo.ai/terms/';
export const SALES_EMAIL = 'sales@qodo.ai';
export const HOW_TO_ADD_REPOSITORIES_URL =
  'https://docs.qodo.ai/qodo-documentation/qodo-aware/getting-started/enterprise-self-hosted/3.-index-your-codebase';
export const CROSS_REPO_RELATIONSHIPS_DOCS_URL =
  'https://docs.qodo.ai/governance/cross-repo-code-review';
export const RESTRICT_TO_REGISTERED_USERS_DOCS_URL =
  'https://docs.qodo.ai/account-management/restrict-reviews-to-registered-users';
export const SSO_DOCS_URL =
  'https://docs.qodo.ai/account-management/single-sign-on-sso';

/**************************
 * IDEs Marketplace URLs
 *************************/
export const VSCODE_MARKETPLACE_URL =
  'https://marketplace.visualstudio.com/items?itemName=Codium.codium';

export const VS_MARKETPLACE_URL =
  'https://marketplace.visualstudio.com/items?itemName=Codium.qodogen';

export const JETBRAINS_MARKETPLACE_URL =
  'https://plugins.jetbrains.com/plugin/21206-codiumai--integrity-agent-powered-by-gpt-3-5-4';
